import { atom } from 'jotai';

export type ReleaseNoteCategory = 'feature' | 'bug_fix' | 'improvement';

export interface IReleaseNote {
    id?: number;
    title: string;
    description: string;
    admin_notes?: string | null;
    superuser_notes?: string | null;
    version: string;
    category: ReleaseNoteCategory;
    created_by?: number;
    created_at?: string;
    updated_at?: string;
}

export const releaseNotesAtom = atom<IReleaseNote[]>([]);
export const releaseNotesLoadingAtom = atom<boolean>(false);
export const releaseNotesPublicAtom = atom<IReleaseNote[]>([]);
export const latestReleaseVersionAtom = atom<string | null>(null);
